import { format } from 'date-fns'

/*
 * Converts a date to unix timestamp format.
 *
 * @example
 * isoDateToUnixTimestamp(new Date('2020-01-01').toISOString())
 *  -> 1577836800000
 */
export const isoDateToUnixTimestamp = date => new Date(date).getTime()

export const ONE_HOUR_IN_MS = 3600000
export const ONE_MINUTE_IN_MS = 60000

// Shared date-time format used for Baplie/Restow timestamps
export const DEFAULT_DATETIME_FORMAT = 'dd/MM/yyyy HH:mm'

// Normalizes backend date-time strings (with or without timezone info) to a Date
export const toLocalDateFromBackend = value => {
  if (!value) {
    return null
  }

  const hasTimezoneInfo =
    /[zZ]$/i.test(value) || /[+-]\d{2}:?\d{2}$/.test(value)
  const normalized = hasTimezoneInfo ? value : `${value}Z`

  const date = new Date(normalized)

  // Guard against invalid dates
  return Number.isNaN(date.getTime()) ? null : date
}

export const formatBackendDateTime = (
  value,
  pattern = DEFAULT_DATETIME_FORMAT
) => {
  const date = toLocalDateFromBackend(value)

  if (!date) {
    return ''
  }

  return format(date, pattern)
}

// Formats a backend date-time string without applying any timezone normalization.
export const formatBackendDateTimeNaive = (
  value,
  pattern = DEFAULT_DATETIME_FORMAT
) => {
  if (!value) {
    return ''
  }

  // Expecting timestamp like "2026-02-25T06:56:53.93891"
  const date = new Date(value)

  if (Number.isNaN(date.getTime())) {
    return ''
  }

  return format(date, pattern)
}
